import { Link } from 'react-router-dom'
import { RegisterForm } from '@/components/auth/RegisterForm'
import { AuthLogo } from '@/components/auth/AuthLogo'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'
import { ROUTES } from '@/utils/constants'
import { useTranslation } from 'react-i18next'
import { Box, Card, CardContent, Typography } from '@mui/material'
import '@/styles/auth.css'

export function RegisterPage() {
  const { t } = useTranslation()

  return (
    <Box className="auth-page">
      <Box className="auth-language-switcher">
        <LanguageSwitcher />
      </Box>
      <Box className="auth-container register">
        <Card className="auth-card">
          <CardContent>
            <AuthLogo />

            <Typography variant="h1" component="h1" sx={{ textAlign: 'center', mb: 1 }}>
              {t('auth.registerTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 3 }}>
              {t('auth.registerSubtitle')}
            </Typography>

            <RegisterForm />

            <Box className="auth-footer">
              <Typography variant="body2">
                {t('auth.haveAccount')}{' '}
                <Link to={ROUTES.LOGIN} className="auth-link">
                  {t('auth.login')}
                </Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}
